module.exports = __webpack_public_path__ + "img/img34.0fa03adf.svg";